import axios from 'axios';
export default axios.create({
    baseURL: 'https://apiDashboard.agrico.mx',
        withCredentials: false
});